import { html, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './link-button.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import {externalLinkHoverText, isExternalUrl, leavingSiteAlertHandler, renderIcon} from '../../utils/link.js';
import { ifDefined } from 'lit/directives/if-defined.js';

export default class LinkButton extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      href: { type: String },
      icon: { type: String },
      ignoredefault: { type: Boolean },
      rightarrowlink: { type: Boolean },
      iconclass: { type: String },
      iconcolor: { type: String },
      icondirection: { type: String },
      linkclass: { type: String },
      srOnly: { type: String },
      target: { type: String },
      id: { type: String },
      title: { type: String },
      arialabel: { type: String },
      arialabelledby: { type: String },
      ignoreExternalUrl: { type: Boolean },
      isHPSite: { type: Boolean },
    };
  }

  constructor() {
    super();
    this.href = '#';
    this.target = '_top';
    this.icon = '';
    this.iconclass = '';
    this.icondirection = 'right';
    this.linkclass = '';
    this.title = '';
    this.ignoredefault = false;
    this.rightarrowlink = false;
    this.id = undefined
    this.arialabel = undefined
    this.arialabelledby = undefined
    this.ignoreExternalUrl = false;
    this.isHPSite = false;
  }

  firstUpdated() {
    if (this.icon == NULL && !this.ignoredefault) {
      this.icon = 'arrow-right';
    }

    if (this.title.length === 0 && this.arialabel && this.arialabel.length > 0) {
      this.title = this.arialabel;
    }

    this.externalUrl = isExternalUrl(this.href)
    this.requestUpdate()
  }

  onClick(event) {
    if (this.externalUrl && !leavingSiteAlertHandler()) {
      event.preventDefault()
    }
  }

  render() {
    return html`
      <a
        @click="${this.onClick}"
        href="${this.href}"
        target="${this.target}"
        title="${isExternalUrl(this.href) ? externalLinkHoverText(this.title) : this.title}"
        class="${classMap({
          'btn__link': true,
          'btn__link--right-arrow-links': this.rightarrowlink,
          'btn__link--external': this.externalUrl,
          [this.linkclass]: this.linkclass !== '',
          'btn__link--hp': this.isHPSite
        })}"
        id=${ifDefined(this.id ? this.id : undefined)}
        aria-label=${ifDefined(this.arialabel ? this.arialabel : undefined)}
        aria-labelledby=${ifDefined(this.arialabelledby ? this.arialabelledby : undefined)}
      >
        <slot></slot>
        ${this.srOnly
          ? html`
              <hf-screenreader-text
                text="${this.srOnly}"
              ></hf-screenreader-text>
            `
          : nothing}
        ${renderIcon(this.href, this.ignoreExternalUrl)}
        ${this.icon.length
          ? html`
              <hf-icon
                name="${this.rightarrowlink ? 'arrow-right' : this.icon}"
                class="${classMap({
                  [this.iconclass]: this.iconclass !== '',
                  'btn__link__icon': true,
                  [`icon-${this.linkclass}`]: this.linkclass !== '',
                  [`btn__link__icon--${this.iconcolor}`]: this.iconcolor && this.iconcolor !== '',
                  'btn__link--icon-right': this.icondirection === 'right',
                  'btn__link--icon-left': this.icondirection === 'left',
                  'btn__link--right-arrow-links': this.rightarrowlink,
                })}"
              ></hf-icon>
            `
          : nothing}
      </a>
    `;
  }
}

customElements.define('hf-link-button', LinkButton);
